import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuOutlined, WhatsAppOutlined, CloseOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import logo from '../../assets/nt_white_logo.png';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isMainPage = location.pathname === '/';
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const scrollTo = (id) => {
        setTimeout(() => {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                console.warn(`Element with ID "${id}" not found for scrolling.`);
            }
        }, 100);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handlePakalpojumiClick = () => {
        if (isMainPage) {
            scrollTo('services');
        } else {
            navigate('/', { state: { scrollToId: 'services' } });
        }
    };

    const handleKontaktiClick = () => {
        if (isMainPage) {
            scrollTo('closer');
        } else {
            navigate('/', { state: { scrollToId: 'closer' } });
        }
    };

    const handlePierakstitiesClick = () => {
        navigate('/signup');
    };

    const handleGalerijaClick = () => {
        navigate('/gallery');
    };

    const handleInternetveikalsClick = () => {
        navigate('/shop');
    };

    return (
        <div className='fixed h-20 w-screen backdrop-blur-lg text-white items-center flex overflow-hidden z-50'>
            <div className='flex flex-row mx-4 md:mx-64 justify-between w-full items-center'>
                <img src={logo} className='w-12 h-12 cursor-pointer' alt='nt_white_logo' onClick={() => navigate('/')} />

                <div className='hidden md:flex gap-4 items-center'>
                    <div onClick={handlePakalpojumiClick} className='hover:text-gray-400 cursor-pointer'>
                        PAKALPOJUMI
                    </div>
                    <div onClick={handleKontaktiClick} className='hover:text-gray-400 cursor-pointer'>
                        KONTAKTI
                    </div>
                    {/* <div onClick={handlePierakstitiesClick} className='hover:text-gray-400 cursor-pointer'>
                        PIERAKSTĪTIES
                    </div> */}
                    <div onClick={handleGalerijaClick} className='hover:text-gray-400 cursor-pointer'>
                        GALERIJA
                    </div>
                    <div onClick={handleInternetveikalsClick} className='hover:text-gray-400 cursor-pointer'>
                        E-VEIKALS
                    </div>
                    <div className='flex items-center gap-2 bg-green-400 px-4 py-2 rounded-sm hover:bg-green-600'>
                        <WhatsAppOutlined />
                        <a href='https://wa.me/37126001205' className='text-xs' target='_blank' rel='noopener noreferrer'>
                            ATVĒRT WHATSAPP
                        </a>
                    </div>
                </div>

                <div className='md:hidden'>
                    <MenuOutlined className='text-2xl cursor-pointer' onClick={toggleMenu} />
                </div>

                <Drawer
                    title=""
                    placement="right"
                    onClose={toggleMenu}
                    open={isMenuOpen}
                    closeIcon={<CloseOutlined style={{ color: 'white', fontSize: '20px' }} />}
                    styles={{
                        header: { 
                            backgroundColor: '#1f2937', 
                            borderBottom: '1px solid #374151',
                            padding: '16px 24px'
                        },
                        body: { 
                            padding: '24px',
                            backgroundColor: '#1f2937', 
                            color: 'white'
                        },
                        mask: {
                            backdropFilter: 'blur(4px)'
                        }
                    }}
                >
                    <div className='flex flex-col gap-8 text-lg'>
                        <div className="space-y-6">
                            <div onClick={() => { handlePakalpojumiClick(); toggleMenu(); }} 
                                className='cursor-pointer hover:text-gray-400 transition-colors duration-200 flex items-center gap-3 group'>
                                <span className="w-1 h-6 bg-green-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                PAKALPOJUMI
                            </div>
                            <div onClick={() => { handleKontaktiClick(); toggleMenu(); }} 
                                className='cursor-pointer hover:text-gray-400 transition-colors duration-200 flex items-center gap-3 group'>
                                <span className="w-1 h-6 bg-green-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                KONTAKTI
                            </div>
                            <div onClick={() => { handleGalerijaClick(); toggleMenu(); }} 
                                className='cursor-pointer hover:text-gray-400 transition-colors duration-200 flex items-center gap-3 group'>
                                <span className="w-1 h-6 bg-green-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                GALERIJA
                            </div>
                            <div onClick={() => { handleInternetveikalsClick(); toggleMenu(); }} 
                                className='cursor-pointer hover:text-gray-400 transition-colors duration-200 flex items-center gap-3 group'>
                                <span className="w-1 h-6 bg-green-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                                E-VEIKALS
                            </div>
                        </div>

                        <div className="border-t border-gray-700 pt-6">
                            <a
                                href='https://wa.me/37126001205'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='flex items-center justify-center gap-3 bg-green-500 px-6 py-4 rounded-lg hover:bg-green-600 text-white text-base transition-all duration-200 hover:shadow-lg hover:shadow-green-500/20'
                                onClick={toggleMenu}
                            >
                                <WhatsAppOutlined style={{ fontSize: '20px' }} />
                                <span>ATVĒRT WHATSAPP</span>
                            </a>
                        </div>
                    </div>
                </Drawer>
            </div>
        </div>
    );
};

export default Header;